<section class="event_group_line" [ngClass]="(isDown) ? '' : 'is-up'">
  <div class="event_group_line_item" (click)="onClickGroup($event)">
    <span class="chevron" [ngClass]="(isDown) ? 'icon-chevron-down' : 'icon-chevron-up'"></span>
    <span class="event_group_line_item_name">
      @if (group.type === eventsLogFieldGroupType.DATE) {
        {{ group.name | date: dateFormat:undefined:language }}
      } @else {
        {{ group.name === "boolean" ? '' : group.name }}
      }
      ({{ group.total }})
    </span>
    <span class="chevron" [ngClass]="(isDown) ? 'icon-chevron-down' : 'icon-chevron-up'"></span>
  </div>
  @if (eventsList && eventsList.list.length > 0) {
    <div class="event_group_line_list">
      <ul>
        @for (event of eventsList.list; track event) {
          <li>
            <app-event [event]=event [tableColumns]="tableColumns"></app-event>
          </li>
        }
      </ul>
      @if (eventsList.paging.nextItemsLink) {
        <div class="show-more" (click)="showMore()">
          <span class="icon-arrow-down-circle show-more-icon"></span>
          <span class="event_group_line_item_name">{{'action.show_more_lines' | translate}}</span>
          <span class="icon-arrow-down-circle show-more-icon"></span>
        </div>
      }
    </div>
  }
  <div>
    <!-- suivant -->
  </div>
</section>
